import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faHome,
    faNewspaper,
    faBars,
    faCalendar,
    faEnvelope,
    faColumns,
    faPager,
    faGears,
    faChevronDown,
    faMapLocationDot,
    faSearch,
    faEllipsisV,
    faBuilding,
    faForward,
    faSitemap,
    faBridge,
    faPenSquare,
    faTh,
    faFileSignature,
    faUsers,
    faDiagramProject,
    faChevronUp,
    faTimes,
    faFileExport,
    faDownload,
    faUpload,
    faArrowAltCircleRight,
    faArrowCircleRight,
    faTruckPickup,
    faSection,
    faBusinessTime,
    faUserTie,
    faHistory,
    faUser,
    faArrowLeft,
    faFilePrescription,
    faCertificate,
    faIndustry,
    faFileContract,
    faCity,
    faFilter,
    faUserLarge,
    faCodeFork,
    faBoxArchive,
    faSignIn,
} from '@fortawesome/free-solid-svg-icons'
import {
    faEye,
    faEyeSlash
} from '@fortawesome/free-regular-svg-icons'

export default function() {
    library.add(faHome);
    library.add(faBars);
    library.add(faPager);
    library.add(faGears);
    library.add(faChevronDown);
    library.add(faChevronUp);
    library.add(faColumns);
    library.add(faNewspaper);
    library.add(faCalendar);
    library.add(faEnvelope);
    library.add(faMapLocationDot);
    library.add(faSearch);
    library.add(faEllipsisV);
    library.add(faEye);
    library.add(faEyeSlash);
    library.add(faBuilding);
    library.add(faForward);
    library.add(faSitemap);
    library.add(faBridge);
    library.add(faTh);
    library.add(faPenSquare);
    library.add(faFileSignature);
    library.add(faUsers);
    library.add(faDiagramProject);
    library.add(faTimes);
    library.add(faFileExport);
    library.add(faDownload);
    library.add(faUpload);
    library.add(faArrowAltCircleRight);
    library.add(faArrowCircleRight);
    library.add(faTruckPickup);
    library.add(faSection);
    library.add(faBusinessTime);
    library.add(faUserTie);
    library.add(faBuilding);
    library.add(faHistory);
    library.add(faUser);
    library.add(faArrowLeft);
    library.add(faIndustry);
    library.add(faFileContract);
    library.add(faCertificate);
    library.add(faCity);
    library.add(faFilter);
    library.add(faCodeFork);
    library.add(faBoxArchive);
    library.add(faSignIn);
}